<template>
  <v-card
    slot="activator"
    raised
    class="dish-card flex ma-2"
    :class="{ opaque }"
    :ripple="!disabled && canAffordDish"
    :hover="!disabled && canAffordDish"
    @contextmenu="e => $emit('oncontextmenu', e)"
  >
    <v-tooltip
      bottom
      :disabled="disabled || canAffordDish"
    >
      <div slot="activator">
        <div style="white-space: nowrap;" class="card">
          <v-avatar class="card-icon">
            <v-icon>account_circle</v-icon>
            <span class="grey--text pl-1">{{ selection.requestsCount }}</span>
          </v-avatar>
          <v-avatar v-if="!hidePrice > 0" class="card-icon mx-1">
            <v-icon :style="{transform: 'scale(0.9)'}">euro_symbol</v-icon>
            <span class="grey--text">{{ selection.price.toFixed(2) }}</span>
          </v-avatar>
          <v-tooltip v-if="selection.maxCount" right class="card-icon">
            <v-avatar slot="activator">
              <v-icon color="yellow darken-4">timer</v-icon>
            </v-avatar>
            <span>{{ $t('dishesContainer.limitedAmount', { limit: selection.maxCount }) }}</span>
          </v-tooltip>
          <v-tooltip v-if="dishesInOrder > 0" right class="card-icon">
            <v-avatar slot="activator" style="right: 12px;">
              <v-badge right color="secondary">
                <v-icon class="pl-1" color="green darken-2">check</v-icon>
                <span v-if="dishesInOrder > 1" slot="badge">{{ dishesInOrder }}</span>
              </v-badge>
            </v-avatar>
            <span v-t="'dishesContainer.youOrderedThisDish'" />
          </v-tooltip>
          <v-tooltip v-if="dishesInCart > 0" right class="card-icon">
            <v-avatar slot="activator" style="right: 12px;">
              <v-badge right color="secondary">
                <v-icon class="pl-1" color="yellow darken-3">shopping_cart</v-icon>
                <span v-if="dishesInCart > 1" slot="badge">{{ dishesInCart }}</span>
              </v-badge>
            </v-avatar>
            <span v-t="'dishesContainer.notSavedYet'" />
          </v-tooltip>
          <v-tooltip v-if="selection.isTopPick" right class="card-icon card-icon-popular" :style="{right: !isIos ? $vuetify.breakpoint.xs ? '-6px' : '0px' : '15px'}">
            <v-avatar slot="activator">
              <v-icon color="orange accent-3">star</v-icon>
            </v-avatar>
            <span v-t="'dishesContainer.popularToday'" />
          </v-tooltip>
          <v-btn
            v-if="!disabled && canAffordDish && isIos"
            icon
            depressed
            :ripple="false"
            style="position: absolute; right: -10px;"
            @click.stop="e => $emit('oncontextmenu', e)"
          >
            <v-icon>more_vert</v-icon>
          </v-btn>
        </div>
        <v-divider />
        <v-card-text>
          <div :class="$vuetify.breakpoint.smAndDown ? 'non-selectable' : ''" :style="{ 'word-wrap': 'break-word' }">{{ dish.title }}</div>
        </v-card-text>
      </div>
      <span v-t="'common.balanceNotSufficient'" />
    </v-tooltip>
  </v-card>
</template>

<script>
export default {
  name: 'SingleDish',
  props: {
    selection: {
      type: Object,
      default: undefined,
    },
    disabled: Boolean,
    dishesInCart: {
      type: Number,
      default: 0,
    },
    dishesInOrder: {
      type: Number,
      default: 0,
    },
    hidePrice: Boolean,
    opaque: Boolean,
    canAffordDish: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    dish() {
      return this.selection.dishes[0];
    },
    isIos() {
      return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    },
  },
};
</script>

<style scoped>

.card {
  position: relative;
  padding: 0 2px;
}

.card-icon {
  width: auto !important;
  min-width: 48px;
}

.card-icon-popular {
  position: absolute;
}

.opaque {
  opacity: 0.5;
}

@media (min-width: 0) {
  .dish-card {
    -ms-flex-preferred-size: calc(100% - 16px);
    flex-basis: calc(100% - 16px);
    max-width: calc(100%- 16px);
  }
}

@media (min-width: 420px) {
  .dish-card {
    -ms-flex-preferred-size: calc(100% / 2 - 16px);
    flex-basis: calc(100% / 2 - 16px);
    max-width: calc(100% / 2 - 16px);
  }
}

@media (min-width: 636px) {
  .dish-card {
    -ms-flex-preferred-size: calc(100% / 3 * 3px);
    flex-basis: calc(100% / 3 - 16px);
    max-width: calc(100% / 3 - 16px);
  }
}

@media (min-width: 1200px) {
  .dish-card {
    -ms-flex-preferred-size: calc(100% / 4 - 16px);
    flex-basis: calc(100% / 4 - 16px);
    max-width: calc(100% / 4 - 16px);
  }
}

@media (min-width: 1400px) {
  .dish-card {
    -ms-flex-preferred-size: calc(100% / 5 - 16px);
    flex-basis: calc(100% / 5 - 16px);
    max-width: calc(100% / 5 - 16px);
  }
}

@media (min-width: 1904px) {
  .dish-card {
    -ms-flex-preferred-size: calc(100% / 6 - 16px);
    flex-basis: calc(100% / 6 - 16px);
    max-width: calc(100% / 6 - 16px);
  }
}
</style>
